import { StargateClient } from "@cosmjs/stargate";
import {api} from "./../ResourceService";

const EXPONENT = 1e9;

export default class Keplr{
	constructor(chainIds, networks){
		this.selectedChain = chainIds[0] ||"";
		this.chainIds = chainIds;
		this.networks = networks;
		this.account = null;
		this.client = null;
	}

	async onChainChanged(id){
		if(this.chainIds.indexOf(id)==-1) return api.handleError(new Error("invalid chain id"));
		await this.setup(id);
	}

	isWalletInstalled(){
		return window.keplr?true:false;
	}

	async setup(chainId = this.chainIds[0]){
		if(!this.isWalletInstalled()) return api.handleError(new Error("Keplr is not installed to your browser, please install the addon to continue"));
		this.selectedChain = chainId;
		await window.keplr.enable(chainId); 
		const offlineSigner = await window.getOfflineSigner(chainId);
        const keplrAccounts = await offlineSigner.getAccounts();
        this.account = keplrAccounts[0];
        this.client = await StargateClient.connect(this.networks[chainId].rpc);
	}

	walletAddress(){
		if(!this.account) return "";
		return this.account.address;
	}

	async walletBalance(){
		if(!this.client || this.account) return "";
		const res = await this.client.getBalance(this.walletAddress());
		return res*1/EXPONENT;
	}
}